import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle, TrendingUp } from 'lucide-react';

export const InvestmentFinanceAdvisory = () => {
  return (
    <div className="service-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">
          <ArrowLeft size={18} />
          Back to Home
        </Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Investment & Finance Advisory</span>
      </div>

      {/* Hero Section */}
      <section className="service-detail-hero">
        <div className="service-detail-icon">
          <TrendingUp size={48} />
        </div>
        <h1 className="service-detail-title">Investment & Finance Advisory</h1>
        <p className="service-detail-subtitle">
          Capital structuring and financing solutions for large-scale infrastructure, real estate, and strategic investment opportunities
        </p>
      </section>

      {/* Overview */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <h2 className="service-section-title">What We Do</h2>
          <p className="service-section-text">
            We offer tailored financing and capital structuring solutions for large projects. Our advisory spans project financing, equity investments, structured debt, and M&A transactions, connecting projects with institutional investors, private equity, and strategic capital partners.
          </p>
        </div>
      </section>

      {/* Services Offered */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <h2 className="service-section-title">Our Services</h2>
          <div className="service-features-grid">
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Project Financing</h3>
              <p className="feature-card-text">
                Comprehensive project financing for real estate, data centres, solar and infrastructure projects with tailored capital structures
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Equity Investments</h3>
              <p className="feature-card-text">
                Equity investments and foreign direct investments (FDI) facilitation with investor matching and deal structuring
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Structured Debt</h3>
              <p className="feature-card-text">
                Structured debt and mezzanine financing solutions optimized for project cash flows and risk profiles
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">M&A Advisory</h3>
              <p className="feature-card-text">
                Mergers & acquisitions advisory including valuation, due diligence, negotiation, and transaction execution
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Investor Network</h3>
              <p className="feature-card-text">
                Access to network of private and institutional investors including family offices, PE funds, and strategic investors
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Capital Structuring</h3>
              <p className="feature-card-text">
                Optimal capital structuring strategies balancing equity, debt, and hybrid instruments for project requirements
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Transaction Size */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="service-pipeline-highlight">
            <h2 className="pipeline-title">Typical Transaction Size</h2>
            <div className="pipeline-metric-large">USD 10 Million+</div>
            <p className="pipeline-description-large">
              Specializing in large-scale financing and capital deployment for infrastructure, real estate, and strategic investments
            </p>
          </div>
        </div>
      </section>

      {/* Current Pipeline */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <div className="service-pipeline-highlight">
            <h2 className="pipeline-title">Current Finance Transactions in Pipeline</h2>
            <div className="pipeline-metric-large">USD 500 Million+</div>
            <p className="pipeline-description-large">
              Ongoing financing mandates across infrastructure, renewable energy and strategic investment opportunities.
            </p>
          </div>
        </div>
      </section>

      {/* Target Sectors */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <h2 className="service-section-title">Target Sectors</h2>
          <div className="sectors-list">
            <div className="sector-item">Real Estate Development</div>
            <div className="sector-item">Data Centres & Digital Infrastructure</div>
            <div className="sector-item">Solar & Renewable Energy</div>
            <div className="sector-item">Infrastructure Projects</div>
            <div className="sector-item">Industrial & Logistics</div>
            <div className="sector-item">Healthcare Infrastructure</div>
            <div className="sector-item">Educational Institutions</div>
            <div className="sector-item">Strategic Acquisitions</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <div className="service-cta-box">
            <h2 className="cta-title">Discuss Financing Opportunities</h2>
            <p className="cta-text">
              Connect with our investment advisory team to explore capital structuring, project financing, or strategic investment opportunities.
            </p>
            <Link to="/#contact" className="btn-primary">
              Schedule Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
